export default __webpack_public_path__ + "static/media/profile.d363651a.jpg";